// addipwhitelistaction.js
import { partnerServices } from "../../config/axios";

export const ADD_IP_WHITELIST_REQUEST = 'ADD_IP_WHITELIST_REQUEST';
export const ADD_IP_WHITELIST_SUCCESS = 'ADD_IP_WHITELIST_SUCCESS';
export const ADD_IP_WHITELIST_FAILURE = 'ADD_IP_WHITELIST_FAILURE';


export const addIpWhitelistAction = (requestData, authToken) => async (dispatch) => {
    dispatch({ type: ADD_IP_WHITELIST_REQUEST });
    await partnerServices
        .post("addIpWhitelist", requestData, {
            headers: { AuthToken: authToken }
        })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: ADD_IP_WHITELIST_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: ADD_IP_WHITELIST_FAILURE, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: ADD_IP_WHITELIST_FAILURE, payload: err.message });
        });
};